import { render, staticRenderFns } from "./settings-organization-test-widget.vue?vue&type=template&id=cbfa200c&scoped=true&"
import script from "./settings-organization-test-widget.vue?vue&type=script&lang=js&"
export * from "./settings-organization-test-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbfa200c",
  null
  
)

export default component.exports